import styled from 'styled-components';
import { BaseSectionHeader } from '../components/ui';

export const PhotosWrapper = styled.div`
  background: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 7px 5px;
  padding: 0px 12px 16px 12px;
`;

export const AllPhotosSectionWrapper = styled.div<{ withBorder?: boolean }>`
  display: flex;
  flex-direction: column;

  border-radius: 8px;
  outline: ${props => (props.withBorder ? '1px solid #3994de' : 'none')};
`;

export const AllPhotosHeader = styled(BaseSectionHeader)`
  background: #ffffff;

  & > span {
    font-size: 14px;
    font-weight: 700;
    line-height: 16.41px;
    color: #000;
  }
`;
